import React, {useContext, useState } from 'react'
import { Button, ButtonGroup, Box, TextField,Typography} from '@material-ui/core'
import { AddShoppingCart, Add, Remove } from '@material-ui/icons';
import { Link } from 'react-router-dom'
import Cookies from "universal-cookie";
import { CartContext } from '../CartContext/CartContext';
import { getPurchaseRules } from '../ProductPurchaseInfo/productPurchase';
import './itemCount.css';

const cookies = new Cookies();


const ItemCount = ({initial, sku, stock, product, price}) => {

	const cartContext = useContext(CartContext);
	const {addToCart}= cartContext;
	const { minimum: minimumQuantity, step: quantityStep } = getPurchaseRules(product, initial);
	const [contador, setContador] = useState(minimumQuantity)
	const [visibilty, setVisibilty] = useState(true)
	const [result, setResult] = useState(stock)
	const productLabel = product?.name || product?.code || sku || "producto";
	const unavailable = product?.disponibilidad === "no disponible";
	const priceUnavailable = Boolean(cookies.get("token")) && !price;
	const addButtonLabel = unavailable
		? "Producto no disponible"
		: (priceUnavailable ? "Precio no disponible" : `Agregar ${contador} al pedido`);

	function roundToNearestFloor(number,multiplo) {
		return Math.floor(number/multiplo) * multiplo;
	}	
	
	function roundToNearestCeil(number,multiplo) {
		return Math.ceil(number/multiplo) * multiplo;
	}

	function addItem() {
		if (quantityStep > 1) {
			if (Number(contador) < Number(result)) {
				let contadorMultiplo=roundToNearestFloor(contador,quantityStep)
				setContador(Number(contadorMultiplo)+quantityStep)
			}
		} else {		
			if (Number(contador) < Number(result)) {
				setContador(Number(contador)+1)
			}
		}
	}

	function removeItem() {
		if (quantityStep > 1) {
			if (Number(contador) > minimumQuantity) {
				let contadorMultiplo=roundToNearestCeil(contador,quantityStep)
				setContador(Math.max(minimumQuantity, Number(contadorMultiplo)-quantityStep))
			}
		} else {
			if (Number(contador)>1) {
				setContador(Number(contador)-1)		
			}
		}
	}

	function addCart(counter) {
		if (product?.disponibilidad === "no disponible") return;
		const token = cookies.get("token");
		if (!token) {
			alert("Debe iniciar sesión para realizar un pedido");
			window.location.href = "/login";
			return;
		}

		if (Number(counter)<=Number(stock)) {
			if (quantityStep > 1) {
				let contadorMultiplo=roundToNearestCeil(contador,quantityStep)
				addToCart(product, Number(contadorMultiplo))
			} else {
				addToCart(product, Number(counter))
			}
			setResult(Number(stock)-Number(counter))
			setContador(minimumQuantity)
			setVisibilty(false)
		}
	}

	function setContadorFunction(e) {
		let value = e.target.value
			if (Number(contador)<Number(stock) && Number(value)>=0) {
				setContador(Number(value))
			} else if (Number(value)>=0) {
				setContador(Number(stock)-1)
			} else {
				setContador(0)
			}		
	}

return (
	<>
	{visibilty ? (
		<Box  sx={{ fontSize: 16, mt: 1, width:"100%", display:"flex", flexDirection:"column", justifyContent:"space-evenly", alignItems:"center", marginX:"5px", maxWidth:"150px" }}>
			<ButtonGroup size="small" variant="contained" aria-label={`Cantidad de ${productLabel}`}>
				<Button aria-label={`Reducir cantidad de ${productLabel}`} disabled={Number(contador) <= Number(minimumQuantity)} onClick={()=>removeItem()}><Remove/></Button>
				{/* <Box component="span" sx={{ fontSize: 12, display:"flex", flexDirection:"row", justifyContent:"space-evenly", alignItems:"center" }}>{contador}</Box> */}
				<Box component="div" sx={{ fontSize: 12, display:"flex", flexDirection:"row", justifyContent:"space-evenly", alignItems:"center",width:"100%" }}>    
					<TextField onChange={(e) => setContadorFunction(e)} sx={{ width:"100%", input: {textAlign: "center" }}}
						type="number"
						value={contador}							
						InputLabelProps={{
						shrink: true,
						}}
						variant="standard"
						inputProps={{
							'aria-label': `Cantidad de ${productLabel}`,
							min: minimumQuantity,
							max: stock,
							step: quantityStep,
						}}
				/></Box>
				<Button aria-label={`Aumentar cantidad de ${productLabel}`} disabled={Number(contador) >= Number(result)} onClick={()=>addItem()}><Add/></Button>
			</ButtonGroup>
			<Box sx={{ width:"100%", mt:{xs:1,md:2} }}>
			{initial ? (
				<>
				<Box sx={{display:"flex"}}>
				<Typography sx={{ fontWeight: "bold", textDecoration: "none", color:"text.primary" }} variant="h6">
					    {/* {price} */}
					  </Typography>
					<Button aria-label={addButtonLabel} title={addButtonLabel} disabled={unavailable || priceUnavailable} size="medium" variant="contained" color="success"  sx={{ fontSize: 12, width:"100%", height:"100%", textAlign:"center" }}
					onClick={()=>addCart(contador)} startIcon={<AddShoppingCart fontSize="small"/>}>Agregar</Button>
				</Box>
								            
				</>

			):(
					<Link to={`/`}>
						<Button size="small" variant="contained" color="primary"  sx={{ fontSize: 12, width:"100%" }}
						>Volver</Button>
					</Link>	
			)}
			</Box>

		</Box>
		
	):(
		<Box  sx={{ fontSize: 16, mt: 1, width:"100%", display:"flex", flexDirection:"row", justifyContent:"space-evenly", alignItems:"center" }}>

			<Link to={`/cart`} style={{ textDecoration:"none", color:"inherit"}}>
				<Button size="small" variant="contained" color="primary"  sx={{ fontSize: 12, width:"100%",  }}>Carrito</Button>
			</Link>
		</Box>

	)}
	</>
)
}

export default ItemCount
